module.exports = __webpack_public_path__ + "img/YT.c0924b3a.svg";